import { Component, Input, EventEmitter, Output, ViewChild, ApplicationRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { ContentCafeProvider } from '../../providers/content-cafe/content-cafe';
import { PopoverController, LoadingController, ModalController, Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { AppState } from '../../config/state';
import { ItemProvider, BibItem } from '../../providers/item/item';
import { GoodreadsProvider } from '../../providers/goodreads/goodreads';

import { PatronProvider } from '../../providers/patron/patron';
import { IlsProvider } from '../../providers/ils/ils';
import { CoHoldPickupPopoverComponent } from '../co-hold-pickup-popover/co-hold-pickup-popover';
import { CoBibHoldingListPopoverComponent } from '../co-bib-holding-list-popover/co-bib-holding-list-popover';
import { MailProvider } from '../../providers/mail/mail';
import { LocationsProvider } from '../../providers/locations/locations';
import { LoginProvider } from '../../providers/login/login';
import { CoBibHoldingListModalPage } from '../../pages/co-bib-holding-list-modal/co-bib-holding-list-modal';
import { AnalyticsProvider } from '../../providers/analytics/analytics';

/**
 * Generated class for the CoBibItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-bib-item',
  templateUrl: 'co-bib-item.html'
})
export class CoBibItemComponent {
  public updateObserver: Subject<Array<number>>;
  detailView: any = 'Overview';
  @Input() novelistDetails: any;
  @Input() bibDetails: BibItem;
  @Input() style: string;
  @Input() originalStyle: string;
  @Input() previousItems: Array<any>;
  reviews: Array<any> = [];
  annotations: Array<any> = [];
  extras: Array<any> = [];
  description: string = "";
  rating: number = null;
  patron: any;
  holdLocationsList: Array<any> = [];
  updateTimer: any;
  // private itemDetails: any = {};
  currentModal: any;
  similarTitleReason: string;
  lastItemViewedTitle: string;
  contentContainer: any;
  novelistTab: string = 'similar';
  goodreadsReviewsWidget: string = '';
  @Output() addItemToList = new EventEmitter<any>();
  @Output() goPreviousItem = new EventEmitter<any>();
  @ViewChild('contentContainer') contentContainerViewChild;
  constructor(private bib : CoBibItemProvider, private contentcafe: ContentCafeProvider, private popoverCtrl: PopoverController, private toast: ToastAlertsProvider, private state: AppState, private bibItem: ItemProvider, public loading: LoadingController, private patronProvider: PatronProvider, private ilsProvider: IlsProvider, private email: MailProvider, private locations : LocationsProvider, private loginProvider: LoginProvider, private modalCtrl : ModalController, private ref : ApplicationRef, private events : Events, private analytics: AnalyticsProvider, private goodreads: GoodreadsProvider) {
    this.events.subscribe('modalIsClosing', ()=>this.goToPreviousItem());
  }
  async showItem(isbn, bypass?) {
    let bookDetails = await this.bib.getParamsFromISBN(isbn);
    if (this.style ==='recommendations'&& !bypass) this.style = 'simple';
    this.novelistDetails = bookDetails.novelistDetails;
    this.bibDetails = bookDetails.bibDetails;
    this.initializeBook(bypass);
    this.contentContainer = this.contentContainerViewChild.nativeElement.parentElement.parentElement;
    this.contentContainer.scroll(0, 0);
  }
  public update() {
    this.updateObserver.next();
  }
  ngOnDestroy() {
    if (this.updateTimer) clearInterval(this.updateTimer);
    this.events.unsubscribe('modalIsClosing');
  }
  ngOnInit(): void {
    this.initializeBook();
  }
  initializeBook(bypass?) {
    // console.log(this.bibDetails)
    if (!bypass) this.addItemToList.emit({bibDetails: this.bibDetails, novelistDetails: this.novelistDetails || null});

    this.annotations = [];
    this.reviews = [];
    this.extras = [];
    this.updateTimer = setInterval(() => this.update(), 500);
    if (!this.bibDetails && this.novelistDetails) {//we dont have bibDetails, lets make a fake one from the novelistData
      this.bibDetails = {
        id: null,
        title: this.novelistDetails.title || "",
        author: this.novelistDetails.author || "",
        available: null,
        format: "",
        publishYear: null,
        isbns: [],
        series: [],
        subjects: [],
        summaries: [], //{text,source}
        notes: [],
      }
    }
    this.updateObserver = new Subject();
    if (this.bibDetails) {
      this.mergeBibDetails(this.bibDetails);
    }

    if (this.novelistDetails) {
      this.rating = this.novelistDetails.rating;
      this.bibDetails.isbns.unshift(this.novelistDetails.primaryISBN);
      if (this.novelistDetails.description) {
        this.description = this.novelistDetails.description;
        this.annotations.push({ text: this.novelistDetails.description, source: 'Novelist' })
      }
      if (this.novelistDetails.seriesInfo) {
        this.novelistDetails.seriesInfo.seriesItems = this.novelistDetails.seriesInfo.seriesItems.map(i => this.loadCover(i));
      }
      if (this.novelistDetails.similarTitles) {
        this.novelistDetails.similarTitles = this.novelistDetails.similarTitles.map(i => this.loadCover(i));
        // console.log(this.novelistDetails.similarTitles[0]);
      }
    }

    if (this.bibDetails && this.bibDetails.isbns && this.bibDetails.isbns.length > 0) {
      this.contentcafe.reviews(this.bibDetails.isbns[0]).then(reviews => {
        if (reviews) {
          this.reviews = this.reviews.concat(reviews);
        }
      });
      this.contentcafe.annotations(this.bibDetails.isbns[0]).then(annotations => {
        if (annotations) {
          this.annotations = this.annotations.concat(annotations);

        }
      });
      this.goodreads.getReviewsWidget(this.bibDetails.isbns[0]).then( (widget: string) => {
        console.log(widget);
        if(widget) this.goodreadsReviewsWidget = widget;
      });
    }
    this.patron = this.state.patron;
    this.annotations = this.annotations.filter((annotation, index, self) => index === self.findIndex((t) => (t.text === annotation.text)))

    if (this.previousItems.length > 1 && this.bibDetails){ // Checks last book for reasoning behind why similar item
      if(this.previousItems[this.previousItems.length-2].novelistDetails && this.previousItems[this.previousItems.length-2].novelistDetails.similarTitles){
        let book = this.previousItems[this.previousItems.length-2].novelistDetails.similarTitles.filter(item =>{
          return (this.bibDetails.isbns.join(',').includes(item.primaryISBN))
        });
        if (book[0] && book[0].reason){
         this.similarTitleReason = book[0].reason;
         this.lastItemViewedTitle = this.previousItems[this.previousItems.length-2].bibDetails.title;
        }
      }
    }
  }
  goToPreviousItem(){
    this.style = this.originalStyle;
    // console.log(this.originalStyle, this.style)
    this.showItem(this.previousItems[0].bibDetails.isbns[0], true);
  }
  mergeBibDetails(bib: BibItem) {
    // console.log(bib);
    if (bib.summaries && bib.summaries.length > 0) {
      this.description = bib.summaries.reduce((ret, s) => { ret += ` ${s.text}`; return ret }, '');
      this.annotations = this.annotations.concat(bib.summaries);
    }
    if (bib.format) this.extras.push({ name: 'Format', value: bib.format });
    if (bib.publishYear) this.extras.push({ name: 'Year', value: bib.publishYear });
    if (bib.subjects) this.extras.push(...bib.subjects.map(s => { return { name: 'Subject', value: s } }));
    if (bib.series) this.extras.push(...bib.series.map(s => { return { name: 'Series', value: s } }));
    if (bib.notes) this.extras.push(...bib.notes.map(s => { return { name: 'Note', value: s } }));
    if (bib.ids) {
      this.extras.push(...bib.ids.map(id => { return { name: id.type, value: id.id } }));
    } else {
      if (bib.isbns) this.extras.push(...bib.isbns.map(s => { return { name: 'ISBN', value: s } }));
      if (bib.upcs) this.extras.push(...bib.upcs.map(s => { return { name: 'UPC', value: s } }));
    }
    if (bib.authors) this.extras.push(...bib.notes.map(s => { return { name: 'Author', value: s } }));
    if (bib.pageCount) this.extras.push({ name: 'Pages', value: bib.pageCount });
    if (bib.language) this.extras.push({ name: 'Language', value: bib.language });
    if (bib.publisher) this.extras.push({ name: 'Publisher', value: bib.publisher });
    if (bib['source']) this.extras.push({ name: 'Source', value: bib['source'] });
    if (bib.id) this.extras.push({ name: 'ID', value: bib.id });
    if (bib.isbns.length > 0) this.extras.push({ name: 'ISBN', value: bib.isbns[0] });
    if (bib.upcs.length > 0) this.extras.push({ name: 'UPC', value: bib.upcs[0] });
    if (bib.averageRating && this.rating) this.rating = bib.averageRating;

    this.extras = this.extras.filter((extra, index, self) => index === self.findIndex((t) => (t.value === extra.value)));
  }
  emailBookInfo(item) {
    this.analytics.trackEvent('Button Clicked', 'Email Book Info', this.bibDetails.title, this.bibDetails.id.toString());
    let customClass = 'custom-email-input-popover';
    let popover = this.popoverCtrl.create(CoEmailInputComponent, { inputType: 'email' }, { cssClass: customClass });
    popover.present({ ev: '' });

    popover.onDidDismiss(email => {
      if (email && email.info) {
        let available;
        this.bibDetails.available? available = "YES" : available = "NONE AVAILABLE";
        let emails = [];
        emails.push({ email: email.info })
        let params = {email: email.info, template: "item_scan_information", phone: ''}
        let vars = {
          title: this.bibDetails.title,
          author: this.bibDetails.author,
          barcode: this.bibDetails.barcode || 'none',
          isbn: this.bibDetails.isbns[0] || 'none',
          upc: this.bibDetails.upcs[0] || 'none',
          available: available,
          description: this.description
        }
        this.email.sendItemInfoEmail(params, vars);
        this.analytics.trackEvent('Library Items', 'Email Item Details', this.bibDetails.title, this.bibDetails.id.toString());
        // let body =
        //   `Dear Patron,
        // Thank you for your interest in ${this.bibDetails.title}!

        // Here is information about the ${this.bibDetails.format}:
        // Title: ${this.bibDetails.title},
        // Author: ${this.bibDetails.author},
        // Barcode #: ${this.bibDetails.barcode || 'none'},
        // ISBN: ${this.bibDetails.isbns[0] || 'none'},
        // UPC: ${this.bibDetails.upcs[0] || 'none'},
        // Available: ${this.bibDetails.available},
        // Description: ${this.description}

        // Thank you
        // `
        // console.log(emails, body)
        // this.email.sendEmailForBrowser(emails, '', 'Your Book information', body);
        this.toast.showAlert('',`Details for '${this.bibDetails.title}' sent to ${email.info}!`,'success');
      }
    })
  }

  placeHold() {
    this.analytics.trackEvent('Button Clicked', 'Place Hold', this.bibDetails.title, this.bibDetails.id.toString());
    this.loginProvider.requireLogin((res) => {
      this.patron = res;
      if (this.patron && this.patron.id) {
        this.ilsProvider.getPickupLocations().then(res => {
          if (res) {
            this.holdLocationsList = res;
            this.openHoldLocationPopup(this.holdLocationsList);
          } else {
            this.toast.showAlert('', 'Error handling request');
          }
        });
      }
    }, null, null, false);
  }
  titleCase(str) {
    return str.toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ');
  }
  openHoldLocationPopup(list) {
    let holdsPopup = this.popoverCtrl.create(CoHoldPickupPopoverComponent, { locations: list, patron: this.patron }, { cssClass: 'place-holds-popover' });
    holdsPopup.present({ ev: '' });
    holdsPopup.onDidDismiss(info => {
      let title = this.titleCase(this.bibDetails.title);
      if (title.length > 30) title = title.split('').slice(0,30).join('') + "...";
      let loader = this.loading.create({
        content: 'Placing your hold...',
      });
      // if (this.state.demo){// TODO: CHANGE BACK AFTER BARCODE LOOKUP IMPLEMENTED
      //   if (info && info.location) {
      //     this.toast.triggerToast(`Request successful, you will be notified when ${title} is available at ${info.location.name}`, '', 'success');
      //   }
      // } else {
        if (info && this.bibDetails.id) {
          // console.log(info, this.patron);
          loader.present();
          this.ilsProvider.placeHold(this.patron.barcode, this.patron.pin, this.bibDetails.id.toString(), info.location.code, 'b').then(res => {
            if (res && res.status) {
              // console.log('wee success')
              this.analytics.trackEvent('Library Items', 'Placed Hold', this.bibDetails.title, this.bibDetails.id.toString());
              this.toast.triggerToast(`Request successful, you will be notified when ${title} is available at ${info.location.name}`, '', 'success');
              loader.dismiss().catch(err=>{});
            } else {
              loader.dismiss().catch(err=>{});
              this.toast.triggerToast(res && res.message ? res.message : 'Error placing your hold, please contact a librarian', '');
            }
          });
        } else if (info) {
          this.toast.triggerToast('Error finding a copy, please contact a librarian', '', 'warning');
        }
      // }
    });
  }

  loadCover(i) {
	const server = Math.floor(Math.random() * 9);
	i.cover = `https://${this.state.client.keyword}.libnet.info/getcover/${i.primaryISBN}`;
    // i.cover = `http://covers${server}.communico.co/isbn/o/${i.primaryISBN}.jpg`;
    i.error = `http://covers${server}.communico.co/gen/cover?title=` + encodeURIComponent(i.title);
    return i;
  }

  findBookCopy() {
    if (this.bibDetails.id) {
      this.ilsProvider.getBibHoldingInfo(this.bibDetails.id.toString()).then(ilsGetBibHoldings => {
        // console.log(ilsGetBibHoldings);
        if (ilsGetBibHoldings) {
          let doesLocationExist = ilsGetBibHoldings.filter(e => e.location !== null);
          if (doesLocationExist.length > 0){
            let holdsPopup = this.modalCtrl.create(CoBibHoldingListModalPage, { locations: ilsGetBibHoldings, bib: this.bibDetails }, {cssClass: "full-screen-modal"});
            holdsPopup.present({ ev: '' });

            holdsPopup.onDidDismiss(info => {
              if (info && info.placeHold) {
                this.placeHold();
              }
            })
          } else {
            this.toast.triggerToast('No locations found, please contact a librarian', '');
          }
        } else {
          this.toast.triggerToast('Error finding a copy, please contact a librarian', '');
        }
      });
      this.analytics.trackEvent('Button Clicked', 'Find a Copy', this.bibDetails.title, this.bibDetails.id.toString());
    } else {
      this.toast.triggerToast('Error finding a copy, please contact a librarian', '');
    }
  }


}


// WEBPACK FOOTER //
// ./src/components/co-bib-item/co-bib-item.ts